import { apiClient, apiClientAuth } from "../config/httpClient";


export function ProductApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {


        findAllHouses: () => http.get(`/api/property/filter/${'Logement'}`),

        findAllFields: () => http.get(`/api/property/filter/${'Terrain'}`),

        findLocalities: () => http.get(`/api/property/count-property-by-region`),

        findHouse: (value) => http.get(`/api/property/limited-filter/${'Logement'}/${value}`),

        findField: (value) => http.get(`/api/property/limited-filter/${'Terrain'}/${value}`),

        findNearestHouse: (lon, lat) => http.get(`/api/property/filter-near-by-user-position/${'Logement'}/${lon}/${lat}`),

        findNearestField: (lon, lat) => http.get(`/api/property/filter-near-by-user-position/${'Terrain'}/${lon}/${lat}`),

        findOne: (id) => http.get(`/api/property/${id}`),

        // Admin
        updateStatus: (propertyId, status) => https.put(`/api/property/update-status/${propertyId}`, status),

        unvalidate: (propertyId, message) => https.put(`/api/property/unvalidate/${propertyId}`, message),

        findAllByStatus: (status) => https.get(`/api/property/find-all-by-status/${status}`),

        insert: (data, companyId) => https.post(`/api/property/${companyId}`, data),   

        update : (id, data) => https.put(`/api/property/${id}`, data), 

        remove : (id) => https.delete(`/api/property/${id}`), 

        //Company
        findAllByStatusAndCompany : (status, companyId) => https.get(`/api/property/find-all-by-status-and-company/${status}/${companyId}`),
  
        findAllBooked : (companyId) => https.get(`/api/property/find-all-booked/${companyId}`),  
   
        getStat : (companyId) => https.get(`/api/property/${companyId}/stats`),  





        

        findBySubtitle: (subtitle) => http.get(`/api/property/filter-by-subtitle/${subtitle}`),

        getStatBySubtitle : () => http.get(`/api/property/stats/by-subtitle`), 

      };
}

